import { HttpClient } from '@lib/HttpClient';
import { getLang } from '@root/src/i18n/client';

const prefix = '/collection';

function normalizeAppearUrl(value: string) {
  const normalized = value.trim().replace(/\/+$/, '');
  return normalized;
}

function resolveAppear(appear?: string) {
  if (appear && appear !== 'undefined' && appear !== 'null') {
    return normalizeAppearUrl(appear);
  }
  if (process.env.NEXT_PUBLIC_APPEAR) {
    return normalizeAppearUrl(process.env.NEXT_PUBLIC_APPEAR);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    const origin = normalizeAppearUrl(window.location.origin);
    if (!origin.includes('localhost') && !origin.includes('127.0.0.1')) {
      return origin;
    }
  }
  return '';
}

export async function getCollection(page, appear?: string) {
  try {
    const appearValue = resolveAppear(appear);
    const appearParam = appearValue
      ? `&appear=${encodeURIComponent(appearValue)}`
      : '';
    const res = await HttpClient.httpGet(
      `${prefix}?lang=${getLang()}&currentPage=${page}${appearParam}`
    );
    return res;
  } catch (error) {
    console.error('Error fetching collection with language client:', error);
    return 'not ok';
  }
}

export async function getAllCollections(appear?: string) {
  try {
    const firstPage = await getCollection(1, appear);

    if (!firstPage || !firstPage.success || !Array.isArray(firstPage.data)) {
      return [];
    }

    const collections = [...firstPage.data];
    const totalPage = Number(firstPage.totalPage || firstPage.totalPages || 1);

    if (totalPage > 1) {
      for (let page = 2; page <= totalPage; page += 1) {
        const pageData = await getCollection(page, appear);
        if (pageData?.success && Array.isArray(pageData.data)) {
          collections.push(...pageData.data);
        }
      }
    }

    return collections;
  } catch (error) {
    console.error('Error fetching all collections client:', error);
    return [];
  }
}

export async function getCollectionBySlug(
  slug: string,
  appear?: string
) {
  const appearValue = resolveAppear(appear);
  const appearParam = appearValue
    ? `&appear=${encodeURIComponent(appearValue)}`
    : '';
  const endpoint = `${prefix}/slug/${encodeURIComponent(slug)}?lang=${getLang()}${appearParam}`;
  try {
    const res = await HttpClient.httpGet(endpoint, {
      headers: { 'Content-Type': 'application/json' },
    });
    return res?.success ? res.item : null;
  } catch (error) {
    console.error('Error fetching collection by slug and language:', error);
    return null;
  }
}

export async function getProductsByCollectionSlug(
  slug: string,
  page: number,
  pageSize: number = 12,
  sort: string = 'newest',
  appear?: string
) {
  const appearValue = resolveAppear(appear);
  const appearParam = appearValue
    ? `&appear=${encodeURIComponent(appearValue)}`
    : '';
  const sortParam = sort ? `&sort=${encodeURIComponent(sort)}` : '';
  const endpoint = `${prefix}/slug/${encodeURIComponent(slug)}/products?lang=${getLang()}&currentPage=${page}&pageSize=${pageSize}${sortParam}${appearParam}`;
  try {
    const res = await HttpClient.httpGet(endpoint, {
      headers: { 'Content-Type': 'application/json' },
    });
    return res;
  } catch (error) {
    console.error('Error fetching collection by slug and language:', error);
    return 'not ok';
  }
}
